import {loadStripe} from "@stripe/stripe-js";
import React, {useState, useEffect, useRef} from 'react'
import agent from "../api/agent";
import {handleError} from "../common/utils";
import {Elements} from "@stripe/react-stripe-js";
import StripePayment from "./StripePayment";
const googleAddressKey = 'AIzaSyDe7SUUVtVJJ5DHYe-ZuKkBV3Wh-fbV7PY'
const loader = 'auto';
const MobileStripeCheckout = ({shippingAddress, invoiceId, invoiceAmount, packageId, stripePublishableKey, paypalClientId, usageBillingEnabled}) => {
  const [clientSecret, setClientSecret] = useState('')
  const [paymentId, setPaymentId] = useState('')
  const [customerOptions, setCustomerOptions] = useState({customer: '', ephemeralKey: ''})
  const [stripePromise, setStripePromise] = useState(null);
  const [usageLoading, setUsageLoading] = useState(false)
  const usageLock = useRef(false)

  const getStripePromise = () => {
    const promise = loadStripe(stripePublishableKey, {apiVersion: '2024-06-20',betas: ['elements_customers_beta_1']})
    setStripePromise(promise)
  }

  const options = {
    clientSecret,
    loader,
    customerOptions
  }
  const processStripeCheckout = async (invoiceId) => {
    try {
      const requestBody = {
        invoiceId: invoiceId
      }

      const response = await agent.checkout.stripeCheckout(requestBody)
      const stripeRes = response.data.data
      setClientSecret(stripeRes.paymentIntent)
      setPaymentId(stripeRes.paymentIntentId)
      setCustomerOptions({customer: stripeRes.stripeCustomerId, ephemeralKey: stripeRes.ephemeralKey})
    } catch (e) {
      handleError(e)
    }
  }

  const usageCheckout = async () => {
    if (usageLock.current) {
      return
    }

    usageLock.current = true

    try {
      setUsageLoading(true)
      await agent.checkout.usageCheckout({ invoiceId, packageId })
      window.location.replace('/mobile/success')
    } catch (e) {
      handleError(e)
    } finally {
      usageLock.current = false
      setUsageLoading(false)
    }
  }

  useEffect(() => {
    if (invoiceId) {
      processStripeCheckout(invoiceId)
    }
  }, [invoiceId])

  useEffect(() => {
    if (stripePublishableKey) {
      getStripePromise()
    }
  },  [stripePublishableKey])

  return (
    <div className="mobile-stripe-checkout">
      {usageBillingEnabled && <button className="btn btn-outline-primary srr-button usage-invoice-button" onClick={usageCheckout} disabled={usageLoading}>
        {usageLoading ? 'Adding to monthly invoice' : 'Add to monthly invoice'}
      </button>}
      {clientSecret && paymentId && customerOptions.customer && <div className={usageLoading ? 'checkout-locked' : ''}>
        <Elements stripe={stripePromise} options={options}>
          <StripePayment shippingAddress={shippingAddress} googleAddressKey={googleAddressKey} invoiceId={invoiceId} invoiceAmount={invoiceAmount} packageId={packageId} paypalClientId={paypalClientId} mobile={true} actionsLocked={usageLoading}/>
        </Elements>
      </div>}
    </div>
  )
}

export default MobileStripeCheckout